"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var sizeMap = {
  screenXs: {
    small: '40px',
    medium: '60px'
  },
  screenSm: {
    small: '48px',
    medium: '96px'
  }
};
var getSize = function getSize() {
  var imageSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'medium';
  var screenSize = arguments.length > 1 ? arguments[1] : undefined;
  var screenMap = sizeMap[screenSize];
  return screenMap[imageSize];
};
var Image = exports.Image = _styledComponents["default"].img.withConfig({
  displayName: "Image",
  componentId: "sc-1yo56tx-0"
})(["", ";flex-shrink:0;margin-inline-end:", ";@media (max-width:", "){inline-size:", ";block-size:", ";}@media (min-width:", "){inline-size:", ";block-size:", ";}"], (0, _index.imageStyle)(), (0, _index.cssSpacing)('tighter', '12px'), _encoreFoundation.screenXsMax, function (props) {
  return getSize(props.$size, 'screenXs');
}, function (props) {
  return getSize(props.$size, 'screenXs');
}, _encoreFoundation.screenSmMin, function (props) {
  return getSize(props.$size, 'screenSm');
}, function (props) {
  return getSize(props.$size, 'screenSm');
});